import { Button, Col, Modal, Row } from "react-bootstrap";
import { NFCeModalPropriedadesProps } from "./NFCe.Modal.Propriedades.Dto";
import NFCeModalPropriedadesCode from "./NFCe.Modal.Propriedades.Code";

const NFCeModalPropriedadesView = ({
  show,
  nfce,
  onCancel,
  onDelete,
  onPrint,
  onDownloadXml,
  onFetchStatus,
}: NFCeModalPropriedadesProps) => {
  const { onCancelClick } = NFCeModalPropriedadesCode(onCancel, onPrint);

  const onDeleteHandler = () => {
    if (nfce) {
      onCancel();
      onDelete(nfce);
    }
  };

  const onPrintHandler = () => {
    if (nfce) {
      onPrint(nfce);
    }
  };

  const onDownloadXmlHandler = () => {
    if (nfce) {
      onDownloadXml(nfce);
    }
  };

  const onFetchStatusHandler = () => {
    if (nfce) {
      onFetchStatus(nfce);
    }
  };

  return (
    <>
      <Modal show={show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFCe: {nfce?.numeroNF}</Col>
            <Col xs={6}>Serie: {nfce?.serie}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Envio: {nfce?.codigoStatusEnvio}-
              {nfce?.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {nfce?.codigoStatusResposta}-
              {nfce?.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onCancelClick}
          >
            Cancelar
          </Button>
          <Button
            variant="outline-danger"
            className="messagebox-btn-cancel"
            onClick={onDeleteHandler}
          >
            Excluir
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onPrintHandler}
          >
            Imprimir
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onDownloadXmlHandler}
          >
            Baixar XML
          </Button>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onFetchStatusHandler}
          >
            Consultar Situação
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NFCeModalPropriedadesView;
